import { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";

import speakersData from "../data/speaker_logos.json";

export const LogoCarouselNew = () => {
   const [speakers, setSpeakers] = useState([])

   useEffect(() => {
      setSpeakers(speakersData);
   }, [])

   let marqueeItems = speakers.map((item, i) =>
      item.logo_url !== null &&
      <div key={i} style={{ display: 'flex', alignItems: 'center', zIndex: '1001' }}>
         <a rel='noreferrer' target="_blank" href={item.website}><img alt='speaker' className="carousel-logo" style={{ objectFit: 'scale-down', maxWidth: '175px', maxHeight: '100px', marginLeft: '1.5rem', marginRight: '1.5rem' }} src={item.logo_url} loading="eager" /></a>
      </div>

   );

   return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
         <h1
            style={{
               flex: 1.5, textAlign: 'center', color: 'black', fontWeight: '900',
               display: window.innerWidth < 1000 ? 'none' : ""
            }}
         >
            OUR FEATURED VCs
         </h1>
         <Marquee speed="22.5"
            style={{ height: "22.5vh", zIndex: '1001', display: 'flex', flex: 3, backgroundColor: 'white' }}>
            {marqueeItems}
         </Marquee>
      </div>
   );
};

/*Props
Property	Type	Default	Description
style	object	{}	Inline style for the container div
className	string	""	Name of the css class to style the container div
play	boolean	true	Whether to play or pause the marquee
pauseOnHover	boolean	false	Whether to pause the marquee when hovered
pauseOnClick	boolean	false	Whether to pause the marquee when clicked
direction	"left" or "right"	"left"	The direction the marquee is sliding
speed	number	20	Speed calculated as pixels/second
delay	number	0	Duration to delay the animation after render, in seconds
loop	number	0	The number of times the marquee should loop, 0 is equivalent to infinite
gradient	boolean	true	Whether to show the gradient or not
gradientColor	Array<number> of length 3	[255, 255, 255]	The rgb color of the gradient as an array of length 3
gradientWidth	number or string	200	The width of the gradient on either side
children	ReactNode	null	The children rendered inside the marquee*/
